// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"1d767dcf","393":"409fb386"}[chunkId] + ".chunk.css";
};